<template>
  <div>
    <CreateNewDeliveryOrder v-if="!forUpdate"></CreateNewDeliveryOrder>
    <UpdateDeliveryOrder v-if="forUpdate" :id="id"></UpdateDeliveryOrder>
  </div>
</template>

<script>
  import CreateNewDeliveryOrder from '@/views/operations/CreateNewDeliveryOrder.vue'
  import UpdateDeliveryOrder from '@/views/operations/UpdateDeliveryOrder.vue'

  export default {
    name: 'InvoiceCreateNew',
    data: () => ({
      id: null
    }),
    watch: {
    },
    computed: {
      forUpdate: function(){
        return this.id ? true : false
      }
    },
    methods: {
    },
    mounted() {
      if(this.$route.params.id != 'add'){
        this.id = this.$route.params.id
      }
    },
    components: {
      CreateNewDeliveryOrder,
      UpdateDeliveryOrder
    }
  }
</script>
